import React, {useEffect, useState} from "react";

// import redux
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../features/store";
import {getUserList, addMemberAction} from "../../features/sliceReducer/projectReducer";
import {userModalCloseAction} from "../../features/sliceReducer/interactionReducer";

//import component
import SearchForm from "../../components/SearchForm";
import PaginationControlled from "../../components/PaginationControlled";

//import material-UI
import {makeStyles, createStyles, withStyles, Theme} from "@material-ui/core/styles";
import {
  Box,
  Button,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from "@material-ui/core";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";

import PersonAddIcon from "@material-ui/icons/PersonAdd";
import Loading from "../../components/Loading";

//material-UI-Style
const StyledTableRow = withStyles((theme: Theme) =>
  createStyles({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  })
)(TableRow);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    paper: {
      width: "1200px",
      height: "840px",
      overflowY: "auto",
      backgroundColor: theme.palette.background.paper,
      border: `2px solid ${theme.palette.primary.main}`,
      boxShadow: theme.shadows[5],
      padding: theme.spacing(3, 6, 3),
    },

    table: {
      // minWidth: 650,
      border: "1px solid #dbdce0",
      "& td": {
        borderBottom: "none",
      },
    },
    tableHead: {
      backgroundColor: theme.palette.gray.light,
    },
    buttonCell: {
      display: "flex",
      justifyContent: "space-around",
    },
    modalTitle: {
      marginBottom: " 30px",
      textAlign: "center",
      fontWeight: "bold",
    },
    searchInput: {
      display: "flex",
      justifyContent: "center",
      marginBottom: " 20px",
    },

    buttonStyle: {
      display: "flex",
      justifyContent: "center",

      "& button": {
        width: "200px",
        height: "40px",
        marginTop: "80px",
      },
    },
  })
);

const AddMemberModal = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const {
    userList,
    loading,
    error,
    maxPage,
    tableHeader: userModalHeader,
  } = useSelector((state: RootState) => state.project);
  const {userModalToggle} = useSelector((state: RootState) => state.interaction);
  const {userToken} = useSelector((state: RootState) => state.auth);

  //search component
  const [searchWord, setSearchWord] = useState<string>("");
  const [page, setPage] = useState<number>(1);
  const searchDispatcher = (page?: number, keyword?: string) => {
    if (page === undefined) page = 1;
    if (keyword === undefined) dispatch(getUserList({userToken, searchWord, page}));
    else dispatch(getUserList({userToken, searchWord: keyword, page}));
  };

  useEffect(() => {
    dispatch(getUserList({userToken}));
  }, [dispatch]);

  return (
    <>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={userModalToggle}
        onClose={() => {
          dispatch(userModalCloseAction());
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={userModalToggle}>
          <TableContainer component={Paper} className={classes.paper}>
            <Loading loading={loading} />
            <Typography className={classes.modalTitle} variant="h5" component="h5">
              프로젝트 참여자 선택
            </Typography>
            <Box className={classes.searchInput}>
              <SearchForm
                setSearchWord={setSearchWord}
                searchDispatcher={searchDispatcher}
                page={page}
                searchWord={searchWord}
              />
            </Box>
            <Table className={classes.table} aria-label="simple table">
              <TableHead className={classes.tableHead}>
                <TableRow>
                  {userModalHeader.map((headerTitle, index) => (
                    <TableCell key={index} align="center">
                      {headerTitle}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {userList?.map((user, index) => (
                  <StyledTableRow key={user.uid}>
                    <TableCell align="center">{user.name}</TableCell>
                    <TableCell align="center">{user.department}</TableCell>
                    <TableCell align="center">{user.email}</TableCell>
                    <TableCell className={classes.buttonCell}>
                      <Button
                        variant="contained"
                        color="primary"
                        startIcon={<PersonAddIcon />}
                        onClick={() => {
                          dispatch(addMemberAction(user.uid));
                          dispatch(userModalCloseAction());
                        }}
                      >
                        참여자 추가
                      </Button>
                    </TableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
            <PaginationControlled
              page={page}
              maxPage={maxPage}
              pageChange={(page: number) => searchDispatcher(page, searchWord)}
            />
          </TableContainer>
        </Fade>
      </Modal>
    </>
  );
};

export default AddMemberModal;
